import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout, firebase_update, firebase_update_client_info, firebase_update_client, firebase_delete_client_address} from "./firebase";

import Level from "./guages/level";
import Pressure from "./guages/pressure";
import Temp from "./guages/temp";
import Heat from "./guages/heat";
import GasLeak from "./guages/gasleak";
import Vaporizer from "./guages/vaporizer";

import Map from "./components/map";


import { useLocation } from 'react-router-dom';


import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { green, red } from '@mui/material/colors';


import FaceIcon from '@mui/icons-material/Face';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PsychologyIcon from '@mui/icons-material/Psychology';
import BuildCircleIcon from '@mui/icons-material/BuildCircle';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import BusinessIcon from '@mui/icons-material/Business';
import EditIcon from '@mui/icons-material/Edit';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';


import { Form, Field } from 'react-final-form';


import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Icon } from "@material-ui/core";

import Avatar from '@mui/material/Avatar';


import LPGTangFull  from "./images/gas_full.svg";
import LPGTang34  from "./images/gas_3_4.svg";
import LPGTang12  from "./images/gas_1_2.svg";
import LPGTang14  from "./images/gas_1_4.svg";
import LPGTangAlarm  from "./images/gas_alarm.svg";
import LPGTangDeactivated  from "./images/gas_deactivated.svg";


import pressureDeplete from "./images/valve_deplete.svg";
import pressureActive from "./images/valve_active.svg";
import pressureStandby from "./images/valve_standby.svg";


//import useWindowScroll from "@react-hook/window-scroll";

import { useSpring, animated } from 'react-spring'

import DeviceStatus from "./DeviceStatus";
import AllDevices from "./AllDevices";


import Styles from './Styles';

function Disabled({ disabled, children }) {
  if (disabled) {
    return (
      <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
        {children}
      </div>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
}

function Client(props){
  const history = useHistory();

  const r = '/clients/' + props.uid;

  const [client_snapshot, loading_client_snapshot, error_db] = useObject(db.ref(r));

  const [formats, setFormats] = React.useState(() => ['activated']);

  const [clientInfo, setClientInfo] = useState();
  const [clientDevices, setClientDevices] = useState([]);
  const [clientSharedDevices, setClientSharedDevices] = useState([]);
  const [clientStatus, setClientStatus] = useState();
  const [userRole, setUserRole] = useState();
  const [clientType, setClientType] = useState();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openChangeType, setOpenChangeType] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  const [isAdmin, setIsAdmin] = useState(false);

  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
      setIsAdmin(sessionStorage.getItem("admin")=="true");

      if(client_snapshot && !loading_client_snapshot)
      {
        //console.log(client_snapshot.val().info)
        setClientInfo(client_snapshot.val().info);
        if(client_snapshot.child("devices").hasChildren())
        {
          var cd = [];
          var shared_cd = [];
          const objectArray = Object.entries(client_snapshot.val().devices);
          objectArray.forEach(([key, value]) => {
            var item = value;
            item.deviceId = key;
            if(item.shared == 'true')
            {
              shared_cd.push(item);
            }
            else
            {
              cd.push(item)
            }
          })
          setClientDevices(cd);
          setClientSharedDevices(shared_cd);
        }
        setClientStatus(client_snapshot.val()['status']);
        setClientType(client_snapshot.val().type);
        //console.log(clientDevices)
      }
  }, [client_snapshot, loading_client_snapshot]);

  if (loading_client_snapshot)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading client data...
              </Typography>
            </Box>
            </div>);
  }


const handleFormat = (event, newFormats) => {
  var a = newFormats.filter(value => value === 'activated');
  var b = newFormats.filter(value => value === 'online');
  var c = newFormats.filter(value => value === 'email');
  //alert(a + ' ' + b + ' ' + c)
  //alert((a == 'activated') + ' ' + (b == 'online') + ' ' + (c == 'email'));
  /*firebase_update_device(device.id, 
    { 
      status: {
        activated: (a == 'activated').toString(),
        online: (b == 'online').toString(),
        email: (c == 'email').toString(),
      }
    });
    setFormats(newFormats);*/
  };


const deleteDevice = () => {
  //console.log("Post start datetime:: " + moment(startDateTime).format("YYYY-MM-DD HH:mm:ss"));
  //console.log("Post end datetime:: " + moment(endDateTime).format("YYYY-MM-DD HH:mm:ss"));
}

const getFirstLetter = (str) => {
  return str.charAt(0);
}

const handleClickOpenEdit = () => {
  setOpenEdit(true);
};

const handleCloseEdit = () => {
  setOpenEdit(false);
};

const handleClickOpenChangeType = () => {
  setOpenChangeType(true);
};

const handleCloseChangeType = () => {
  setOpenChangeType(false);
};



const handleCloseAdd = () => {
  setOpenAdd(false);
};

const handleCloseDelete = () => {
  setOpenDelete(false);
};


const onSubmit = async values => {
  //window.alert(JSON.stringify(values,0,2))
  await firebase_update_client_info(props.uid, values);
  setOpenEdit(false);
}

const onSubmitChangeType = async values => {
  //window.alert(JSON.stringify(values,0,2))
  await firebase_update_client(props.uid, values);
  setOpenChangeType(false);
}


  return (<div className="container">  
          {
            clientInfo  && (
              <Grid container spacing={2} >
                {((clientType=='store') || (isAdmin)) && <Grid item xs={12}>
                <Card>
                    <CardHeader
                      avatar={
                        <Avatar>{getFirstLetter(clientInfo.title)}</Avatar>
                      }
                      action={
                        <IconButton aria-label="settings" onClick={handleClick}>
                          <MoreVertIcon/>
                        </IconButton>
                      }
                      title={clientInfo.title}
                      subheader={clientType=='store'? "store owner" : "general user"}
                    />
                    <CardContent>
                    <Disabled disabled={clientType=='general'}>
                    <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
                      <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                          <Avatar sx={{ width: 32, height: 32, bgcolor: red[500] }}>
                            <BusinessIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={clientInfo.title}
                          secondary={
                            <Stack direction="column" spacing={0}>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="caption"
                                color="text.primary">
                                {clientInfo.desc}
                              </Typography>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                              {"Street : " + clientInfo.street}
                              </Typography>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                              {"Subdistrict : " + clientInfo.subdistrict}
                              </Typography>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                              {"District : " + clientInfo.district}
                              </Typography>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                              {"Province : " + clientInfo.province}
                              </Typography>
                              <Typography
                                sx={{ display: 'inline' }}
                                component="span"
                                variant="body2"
                                color="text.primary"
                              >
                              {"Postcode : " + clientInfo.postcode}
                              </Typography>
                            </Stack>
                          }
                        />
                      </ListItem>
                      </List>
                      </Disabled>
                    </CardContent>
                    <Menu
                      anchorEl={anchorEl}
                      id="account-menu"
                      open={open}
                      onClose={handleClose}
                      onClick={handleClose}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: 'visible',
                          filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                          mt: 1.5,
                          '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                          },
                          '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                    >
                      <MenuItem onClick={handleClickOpenEdit}>
                        <ListItemIcon>
                          <EditIcon />
                        </ListItemIcon> Edit Store Detail
                      </MenuItem>
                      {isAdmin && 
                      <MenuItem onClick={handleClickOpenChangeType}>
                        <ListItemIcon>
                          {clientType=='store' ? <BusinessIcon /> : <AccountBoxIcon />}
                        </ListItemIcon> Change Client Type
                      </MenuItem> }
                    </Menu>
                    <Dialog open={openEdit} onClose={handleCloseEdit} maxWidth={"lg"} fullWidth={true}>
                    <DialogTitle>Edit Client Address</DialogTitle>
                    <DialogContent>
                    <DialogContentText>
                        Edit client info and update to database.
                    </DialogContentText>
                        <Styles>
                        <Form
                            onSubmit={onSubmit}
                            initialValues={{
                                            title: clientInfo.title,
                                            desc: clientInfo.desc,
                                            street: (clientInfo.street ? clientInfo.street : "-"),
                                            subdistrict: (clientInfo.subdistrict ? clientInfo.subdistrict : "-"),
                                            district: (clientInfo.district ? clientInfo.district : "-"),
                                            province: (clientInfo.province ? clientInfo.province : "-"),
                                            postcode: (clientInfo.postcode ? clientInfo.postcode : "-"),
                                          }}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form onSubmit={handleSubmit}>
                                <div>
                                    <label>Store Title</label>
                                    <Field
                                    name="title"
                                    component="input"
                                    type="text"
                                    placeholder="Super Mart"
                                    />
                                </div>   
                                <div>
                                    <label>Description</label>
                                    <Field
                                    name="desc"
                                    component="input"
                                    type="text"
                                    placeholder="@Area 51"
                                    />
                                </div>                  
                                <div>
                                    <label>Street</label>
                                    <Field
                                    name="street"
                                    component="input"
                                    type="text"
                                    placeholder="111 High speed Rd."
                                    />
                                </div>
                                <div>
                                    <label>Subdistrict</label>
                                    <Field
                                    name="subdistrict"
                                    component="input"
                                    type="text"
                                    placeholder="Suranaree"
                                    />
                                </div>
                                <div>
                                    <label>District</label>
                                    <Field
                                    name="district"
                                    component="input"
                                    type="text"
                                    placeholder="Muang"
                                    />
                                </div>
                                <div>
                                    <label>Province</label>
                                    <Field
                                    name="province"
                                    component="input"
                                    type="text"
                                    placeholder="Nakhon Ratchasima"
                                    />
                                </div>
                                <div>
                                    <label>Zip Code</label>
                                    <Field
                                    name="postcode"
                                    component="input"
                                    type="text"
                                    placeholder="30000"
                                    />
                                </div>

                                <div className="buttons">
                                    <button type="submit" disabled={submitting || pristine}>
                                        Update Client Address
                                    </button>
                                    <button
                                    type="button"
                                    onClick={form.reset}
                                    disabled={submitting || pristine}
                                    >
                                    Reset
                                    </button>
                                    <button
                                    type="button"
                                    onClick={handleCloseEdit}
                                    >
                                    Cancel
                                    </button>
                                </div>
                                {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
                                </form>
                            )}
                            />
                            </Styles>
                        </DialogContent>
                    </Dialog>

                    <Dialog open={openChangeType} onClose={handleCloseChangeType} maxWidth={"md"} fullWidth={true}>
                    <DialogTitle>Change Client Type</DialogTitle>
                    <DialogContent>
                    <DialogContentText>
                        Change client type. By switching from 'Store' to 'General' client type, the current store's details will still be kept on database but will not be shown. By changing from 'General' to 'Store', the previous store detail will be retrieved and displayed. Store detail can be further edited.
                    </DialogContentText>
                        <Styles>
                        <Form
                            onSubmit={onSubmitChangeType}
                            initialValues={{
                                            type: clientType,
                                          }}
                            render={({ handleSubmit, form, submitting, pristine, values }) => (
                                <form onSubmit={handleSubmit}>
                                <div>
                                  <label>Type</label>
                                  <div>
                                    <label>
                                      <Field
                                        name="type"
                                        component="input"
                                        type="radio"
                                        value="store"
                                      />{' '}
                                      Store (owner of devices and can share them with other clients)
                                    </label>
                                    <label>
                                      <Field
                                        name="type"
                                        component="input"
                                        type="radio"
                                        value="general"
                                      />{' '}
                                      General User (only can view shared devices)
                                    </label>
                                    
                                  </div>
                                </div> 
                                

                                <div className="buttons">
                                    <button type="submit" disabled={submitting || pristine}>
                                        Update Client Type
                                    </button>
                                    <button
                                    type="button"
                                    onClick={form.reset}
                                    disabled={submitting || pristine}
                                    >
                                    Reset
                                    </button>
                                    <button
                                    type="button"
                                    onClick={handleCloseChangeType}
                                    >
                                    Cancel
                                    </button>
                                </div>
                                {/*<pre>{JSON.stringify(values, 0, 2)}</pre>*/}
                                </form>
                            )}
                            />
                            </Styles>
                        </DialogContent>
                    </Dialog>
                  </Card>
                  </Grid>}
                  {/*
                  <Grid item xs={12}>
                    {clientInfo ? (
                      <Card style={{height: '100%'}}>
                          <CardContent>
                              <Typography variant="h6" component="div">
                              {clientDevices ? (clientDevices.length + clientSharedDevices.length):(<div></div>)} LPG Devices
                              {clientInfo ? (<Typography>By {clientInfo.title}</Typography>) : (<div></div>)}
                              </Typography>
                              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                              All device list for this client.
                              </Typography>
                              <Typography variant="body2">
                              All devices in the system from this client, both activated and not-yet-activated, is listing here. Each device can be viewed, edited, or deleted depend on authorization level.
                              </Typography>
                              <Grid container spacing={2} sx={{p: 2}}>
                                <Grid item xs={12}>
                                  {(clientType == 'store') && <div>
                                <Divider><Chip label={clientDevices.length + " Own Devices"}/></Divider>
                                    <ImageList sx={{ width: '100%', height: 'vh' , p: 4}} cols={5}>
                                      { 
                                        clientDevices && (
                                          clientDevices.map((device) => (
                                            <ImageListItem key={device.deviceId} >
                                              {clientInfo ? (<div><DeviceStatus deviceId={device.deviceId} showTitle={true} scale={1} uid={props.uid} clientTitle={clientInfo.title} shared={device.shared} /></div>):(<div></div>)}
                                            </ImageListItem>)
                                          ))
                                        }
                                    </ImageList>
                                    </div>}
                                    <Divider><Chip label={clientSharedDevices.length + " Shared Devices"} /></Divider>
                                    <ImageList sx={{ width: '100%', height: 'vh' , p: 4}} cols={5}>
                                      { 
                                        clientSharedDevices && (
                                          clientSharedDevices.map((device) => (
                                              <ImageListItem key={device.deviceId} >
                                              {clientInfo && (<div><DeviceStatus deviceId={device.deviceId} showTitle={true} scale={1} uid={props.uid} clientTitle={clientInfo.title} shared={device.shared} /></div>)}
                                            </ImageListItem>)
                                          ))
                                        }
                                    </ImageList>
                                </Grid>
                            </Grid>
                          </CardContent>
                      </Card>
                    ):
                    (<div></div>)}
                      
                  </Grid>
                  */}
                  </Grid>
            )
          }
          
    </div>);
}

export default Client;
